/* eslint-disable react/prop-types */
import React from 'react';
import ReactPlayerVideo from './react-player-video';

interface VimeoVideoProps {
    videoId: string;
    title: string;
    onError: (error: unknown) => void;
}

const VimeoVideo: React.FC<VimeoVideoProps> = ({ videoId, title, onError }) => {
    if (!videoId) {
        onError('Vimeo video ID is empty');
        return null;
    }

    return (
        <ReactPlayerVideo
            url={`https://player.vimeo.com/video/${encodeURIComponent(
                videoId
            )}`}
            title={title}
            onError={onError}
        />
    );
};

export default VimeoVideo;
